const carExtrasTranslations = {
    "carExtraAbs": "ABS",
    "carExtraAdaptiveCorneringLights": "Adaptive Cornering Lights",
    "carExtraAdaptiveLighting": "Adaptive Lighting",
    "carExtraAirSuspension": "Air Suspension",
    "carExtraAlarmSystem": "Alarm System",
    "carExtraAllSeasonTyres": "All-Season Tyres",
    "carExtraAlloyWheels": "Alloy Wheels",
    "carExtraAmbientLighting": "Ambient Lighting",
    "carExtraAndroidAuto": "Android Auto",
    "carExtraAppleCarplay": "Apple CarPlay",
    "carExtraArmRest": "Arm Rest",
    "carExtraAutoDimmingInteriorMirror": "Auto-Dimming Interior Mirror",
    "carExtraAuxiliaryHeating": "Auxiliary Heating",
    "carExtraBiXenonHeadlights": "Bi-Xenon Headlights",
    "carExtraBlindSpotAssist": "Blind Spot Assist",
    "carExtraBluetooth": "Bluetooth",
    "carExtraCdPlayer": "CD Player",
    "carExtraCentralLocking": "Central Locking",
    "carExtraDabRadio": "DAB Radio",
    "carExtraDaytimeRunningLights": "Daytime Running Lights",
    "carExtraDigitalCockpit": "Digital Cockpit",
    "carExtraDisabledAccessible": "Disabled Accessible",
    "carExtraDistanceWarningSystem": "Distance Warning System",
    "carExtraDynamicChassisControl": "Dynamic Chassis Control",
    "carExtraElectricBackseatAdjustment": "Electric Backseat Adjustment",
    "carExtraElectricSeatAdjustment": "Electric Seat Adjustment",
    "carExtraElectricSideMirror": "Electric Side Mirror",
    "carExtraElectricTailgate": "Electric Tailgate",
    "carExtraElectricWindows": "Electric Windows",
    "carExtraEmergencyBrakeAssist": "Emergency Brake Assist",
    "carExtraEmergencyCallSystem": "Emergency Call System",
    "carExtraEmergencyTyre": "Emergency Tyre",
    "carExtraEmergencyTyreRepairKit": "Emergency Tyre Repair Kit",
    "carExtraEsp": "ESP",
    "carExtraFatigueWarningSystem": "Fatigue Warning System",
    "carExtraFogLamps": "Fog Lamps",
    "carExtraFoldFlatPassengerSeat": "Fold Flat Passenger Seat",
    "carExtraFoldingExteriorMirrors": "Folding Exterior Mirrors",
    "carExtraFoldingRoof": "Folding Roof",
    "carExtraFourWheelDrive": "Four-Wheel Drive",
    "carExtraGlareFreeHighBeamHeadlights": "Glare-Free High-Beam Headlights",
    "carExtraHandsFreeKit": "Hands-Free Kit",
    "carExtraHeadUpDisplay": "Head-Up Display",
    "carExtraHeadlightWasherSystem": "Headlight Washer System",
    "carExtraHeatedRearSeats": "Heated Rear Seats",
    "carExtraHeatedSeats": "Heated Seats",
    "carExtraHeatedSteeringWheel": "Heated Steering Wheel",
    "carExtraHeatedWindshield": "Heated Windshield",
    "carExtraHighBeamAssist": "High-Beam Assist",
    "carExtraHillStartAssist": "Hill Start-Assist",
    "carExtraImmobilizer": "Immobilizer",
    "carExtraInductionChargingForSmartphones": "Induction Charging For Smartphones",
    "carExtraIntegratedMusicStreaming": "Integrated Music Streaming",
    "carExtraIsofix": "Isofix",
    "carExtraKeylessCentralLocking": "Keyless Central Locking",
    "carExtraLaneChangeAssist": "Lane-Change Assist",
    "carExtraLaserHeadlights": "Laser Headlights",
    "carExtraLeatherSteeringWheel": "Leather Steering Wheel",
    "carExtraLedHeadlights": "LED Headlights",
    "carExtraLedRunningLights": "LED Running Lights",
    "carExtraLightSensor": "Light Sensor",
    "carExtraLumbarSupport": "Lumbar Support",
    "carExtraMassageSeats": "Massage Seats",
    "carExtraMultifunctionSteeringWheel": "Multifunction Steering Wheel",
    "carExtraNavigationSystem": "Navigation System",
    "carExtraNightVisionAssist": "Night-Vision Assist",
    "carExtraOnBoardComputer": "On-Board Computer",
    "carExtraPaddleShifters": "Paddle Shifters",
    "carExtraPanoramicRoof": "Panoramic Roof",
    "carExtraPassengerSeatIsofixPoint": "Passenger Seat Isofix",
    "carExtraPowerAssistedSteering": "Power-Assisted Steering",
    "carExtraRadio": "Radio",
    "carExtraRainSensor": "Rain Sensor",
    "carExtraRoofRack": "Roof Rack",
    "carExtraSeatVentilation": "Seat Ventilation",
    "carExtraSmokerPackage": "Smoker Package",
    "carExtraSoundSystem": "Sound System",
    "carExtraSpareTyre": "Spare Tyre",
    "carExtraSpeedLimitControlSystem": "Speed Limit Control System",
    "carExtraSportSeats": "Sport Seats",
    "carExtraSportsPackage": "Sports Package",
    "carExtraSportsSuspension": "Sports Suspension",
    "carExtraStartStopSystem": "Start-Stop System",
    "carExtraSteelWheels": "Steel Wheels",
    "carExtraSunroof": "Sunroof",
    "carExtraTintedWindows": "Tinted Windows",
    "carExtraTouchscreen": "Touchscreen",
    "carExtraTractionControl": "Traction Control",
    "carExtraTrafficSignRecognition": "Traffic Sign Recognition",
    "carExtraTv": "TV",
    "carExtraTyrePressureMonitoring": "Tyre Pressure Monitoring",
    "carExtraUsbPort": "USB Port",
    "carExtraVirtualSideMirrors": "Virtual Side Mirrors",
    "carExtraVoiceControl": "Voice Control",
    "carExtraWlanWifiHotspot": "WiFi Hotspot",
    "carExtraXenonHeadlights": "Xenon Headlights",
    "carExtraKeylessEntry": "Keyless Entry",
    "carExtraParkingAssist": "Parking Assist",
    "carExtraParkingSensors": "Parking Sensors",
    "carExtraAutomaticParking": "Automatic Parking",
    "carExtraParkingCamera": "Parking Camera",
    "carExtraSideAirbags": "Side Airbags",
    "carExtraRearViewCamera": "Rear View Camera",
    "carExtraLaneDepartureWarning": "Lane Change Warning",
    "carExtraSurroundViewCamera": "Surround View Camera",
    "carExtraSlidingDoors": "Sliding Doors",
    "carExtraPrivacyGlass": "Privacy Glass",
    "carExtraPowerSteering": "Power Steering",
    "carExtraAdaptiveCruiseControl": "Cruise Control",
    "carExtraLeatherSeats": "Leather Seats",
    "carExtraUsb": "USB"
};

export default carExtrasTranslations;  